import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useNavigation } from '../../../utils/contexts/NavigationContext'
import IconsMenu, { IconsMenuItem } from '../../../components/navigation/IconsMenu'

const items = [
  { label: 'serviceOrders', icon: 'RiInboxFill', to: '/service-orders/list', permission: 'listServiceOrder' },
  { label: 'users', icon: 'RiAccountBoxLine', to: '/users/list', permission: 'listUser' },
  { label: 'location', icon: 'RiMapPinLine', to: '/places/location', permission: 'listLocation' },
  { label: 'profile', icon: 'RiSettings4Line', to: '/profile' }
]

const ItemMenu = ({ label, active, to, permission, ...props }) => {
  const { t } = useTranslation('menu')
  const valid = useSessionPermission(permission)
  const navigate = useNavigation()
  if (!!permission && !valid) return false

  return (
    <IconsMenuItem key={label} active={label === active} label={t(label)} onClick={() => navigate(to)} {...props} />
  )
}

const MMainMenu = ({ active }) => {
  return (
    <IconsMenu>
      {items.map(props => (
        <ItemMenu key={props.label} active={active} {...props} />
      ))}
    </IconsMenu>
  )
}

export default MMainMenu
